"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withTranslations = void 0;
var tslib_1 = require("tslib");
/* eslint react/display-name: 0 */
var React = require("react");
var utils_1 = require("@wix/wixstores-client-core/dist/src/viewer-script/utils");
var _ = require("lodash");
function getTranslation(translations) {
    return function (translationKey, values) {
        return utils_1.translate(translations[translationKey], values);
    };
}
exports.withTranslations = function (textsMapProp) {
    if (textsMapProp === void 0) { textsMapProp = 'globals.textsMap'; }
    return function (Component) {
        return React.forwardRef(function (props, ref) {
            return React.createElement(Component, tslib_1.__assign({}, props, { ref: ref, t: getTranslation(_.get(props, textsMapProp)) }));
        });
    };
};
//# sourceMappingURL=translations.js.map